import React, { useEffect, useState } from 'react'
import { Button, Drawer, Layout, Menu, Row } from "antd";
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import { NavLink, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useHistory } from 'react-router';
import { faBars, faFlag, faHome, faLightbulb, faScroll, faUsers, faClapperboard, faCalendar, faCalendarCheck, faCalendarDays, faCalendarDay, faBuilding, faLandmark, faL } from '@fortawesome/free-solid-svg-icons';
import { Header } from 'antd/lib/layout/layout';
import { CodeIcon, HeartFillIcon } from '@primer/octicons-react'
import '../styles/Base.scss'

const { Sider, Content, Footer } = Layout;

export default function DefaultLayout(props: any) {

    const screen = useBreakpoint()
    const [collapsed, setCollapsed] = useState(screen.md);
    const history = useHistory();

    const [drawerVisible, setDrawerVisible] = useState<boolean>(false);

    useEffect(() => {
        setCollapsed(screen.md ? false : true)
    }, [screen.md])

    const onCollapse = (collapsed: boolean) => {
        setCollapsed(collapsed)
    };

    return (
        <Layout style={{ fontSize: screen.md ? "16px" : "14px" }}>
            {screen.md ? <Sider
                theme="dark"
                collapsible
                collapsed={collapsed}
                onCollapse={onCollapse}
                width={220}
            >
                <div style={{ textAlign: "center", paddingBottom: "16px", paddingTop: "6px", backgroundColor:'#f0f2f5'/* , borderRight:'3px solid black' */}}>
                    <NavLink to="/">
                        {
                            // collapsed ? <img height={"50px"} width={"40px"} style={{ objectFit: "contain", paddingTop: "7px", marginBottom: "7px" }} src={process.env.PUBLIC_URL + 'assets/qut_square_logo.png'} /> :
                            //     <img height={"50px"} width={"200px"} style={{ objectFit: "contain", paddingTop: "7px", marginBottom: "7px" }} src={process.env.PUBLIC_URL + 'assets/qut_logo_t.png'} />
                            collapsed ? <img alt="logo_small" height={"60px"} width={"50px"} /* width={"60px"} */ style={{ objectFit: "cover", marginTop: "4px", marginBottom: "2px" }} src={process.env.PUBLIC_URL + '/assets/UNESCO-Collapsed.png'} /> :
                                <img alt="logo_full" height={"80px"} style={{ objectFit: "cover", marginTop: "4px", marginBottom: "2px" , height: "140px"}} src={process.env.PUBLIC_URL + '/assets/b2.png'} />
                        }
                    </NavLink>
                </div>
                <Menu theme='dark' mode='inline' defaultSelectedKeys={["1"]}>
                    <Menu.Item key='1' icon={<FontAwesomeIcon icon={faHome} />}>
                        <Link className="link" to='/' style={{ fontFamily: "Raleway", fontWeight: "bold" , fontSize: "16px"}}>Home</Link>
                    </Menu.Item>
                    <Menu.Item key='2' icon={<FontAwesomeIcon icon={faFlag} />}>
                        <Link className="link" to='/our-mission' style={{ fontFamily: "Raleway", fontWeight: "bold", fontSize: "16px" }} > Our Misson</Link>
                    </Menu.Item>
                    <Menu.Item key='3' icon={<FontAwesomeIcon icon={faCalendarDays} />}>
                        <Link className="link" to='/news-events' style={{ fontFamily: "Raleway", fontWeight: "bold" , fontSize: "16px"}} > News and Events</Link>
                    </Menu.Item>
                    <Menu.Item key='4' icon={<FontAwesomeIcon icon={faUsers} />}>
                        <Link className="link" to='/members' style={{ fontFamily: "Raleway", fontWeight: "bold" , fontSize: "16px"}}>Our People</Link>
                    </Menu.Item>
                    <Menu.Item key='5' icon={<FontAwesomeIcon icon={faLandmark} />}>
                        <Link className="link" to='/partner-institutions' style={{ fontFamily: "Raleway", fontWeight: "bold" , fontSize: "16px"}}>Partner Institutions</Link>
                    </Menu.Item>
                    <Menu.Item key='8' icon={<FontAwesomeIcon icon={faBuilding} />}>
                    <Link
                        className="link"
                        to='/unesco-networks'
                        style={{ fontFamily: "Raleway", fontWeight: "bold", fontSize: "16px" }}
                    >
                        UNESCO Networks
                    </Link>
                    </Menu.Item>
                    <Menu.Item key='6' icon={<FontAwesomeIcon icon={faScroll} />}>
                        <Link className="link" to='/publications' style={{ fontFamily: "Raleway", fontWeight: "bold" , fontSize: "16px"}}>Publications</Link>
                    </Menu.Item>
                    <Menu.Item key='7' icon={<FontAwesomeIcon icon={faClapperboard} />}>
                        <Link className="link" to='/videos' style={{ fontFamily: "Raleway", fontWeight: "bold", fontSize: "16px" }}>UNESCO-Tube</Link>
                    </Menu.Item>
                </Menu>
            </Sider>
                : <Drawer placement="left" onClose={() => setDrawerVisible(false)} visible={drawerVisible} width="256px" bodyStyle={{ padding: 0, backgroundColor: "#001628", minHeight: "100vh" }} style={{ zIndex: 10000, }}>
                    <div style={{ textAlign: "center", paddingBottom: "16px", paddingTop: "26px", width: "256px", backgroundColor:'#f0f2f5' }}>
                        <NavLink to="/">
                            {
                                <img alt="logo_full" height={"80px"} style={{ objectFit: "cover", marginTop: "4px", marginBottom: "2px" }} src={process.env.PUBLIC_URL + '/assets/b2.png'} />
                            }
                        </NavLink>
                    </div>
                    <Menu theme='dark' mode="inline" defaultSelectedKeys={["1"]} style={{ width: "256px" }}>
                        <Menu.Item key='1' icon={<FontAwesomeIcon icon={faHome} />} onClick={() => {
                            history.push("/");
                            setDrawerVisible(false);
                        }}>
                            <div style={{ fontFamily: "Raleway", fontWeight: "bold" }}>Home</div>
                        </Menu.Item>
                        <Menu.Item key='2' icon={<FontAwesomeIcon icon={faFlag} />} onClick={() => {
                            history.push("/our-mission");
                            setDrawerVisible(false);
                        }}>
                            <div style={{ fontFamily: "Raleway", fontWeight: "bold" }} >Our Mission </div>
                        </Menu.Item>
                        <Menu.Item key='3' icon={<FontAwesomeIcon icon={faCalendarDays} />} onClick={() => {
                            history.push("/news-events");
                            setDrawerVisible(false);
                        }}>
                            <div style={{ fontFamily: "Raleway", fontWeight: "bold" }} >News and Events </div>
                        </Menu.Item>
                        <Menu.Item key='4' icon={<FontAwesomeIcon icon={faUsers} />} onClick={() => {
                            history.push("/members");
                            setDrawerVisible(false);
                        }}>
                            <div style={{ fontFamily: "Raleway", fontWeight: "bold" }}>Our People</div>
                        </Menu.Item>
                        <Menu.Item key='5' icon={<FontAwesomeIcon icon={faLandmark} />} onClick={() => {
                            history.push("/partner-institutions");
                            setDrawerVisible(false);
                        }}>
                            <div style={{ fontFamily: "Raleway", fontWeight: "bold" }}>Partner Institutions</div>
                        </Menu.Item>
                        <Menu.Item
                        key='8'
                        icon={<FontAwesomeIcon icon={faBuilding} />}
                        onClick={() => {
                            history.push("/unesco-networks");
                            setDrawerVisible(false);
                        }}
                        >
                        <div style={{ fontFamily: "Raleway", fontWeight: "bold" }}>UNESCO Networks</div>
                        </Menu.Item>
                        <Menu.Item key='6' icon={<FontAwesomeIcon icon={faScroll} />} onClick={() => {
                            history.push("/publications");
                            setDrawerVisible(false);
                        }}>
                            <div style={{ fontFamily: "Raleway", fontWeight: "bold" }}>Publications</div>
                        </Menu.Item>
                        <Menu.Item key='7' icon={<FontAwesomeIcon icon={faClapperboard}/>} onClick={() => {
                            history.push("/videos");
                            setDrawerVisible(false);
                        }}>
                            <div style={{ fontFamily: "Raleway", fontWeight: "bold" }}>UNESCO-Tube</div>
                        </Menu.Item>
                        {/* <Menu.Item key='7' icon={<FontAwesomeIcon icon={faBrain} />}>
                    <Link to='/playground'>Algorithms in Action</Link>
                </Menu.Item> */}
                    </Menu>
                </Drawer>

            }
            {
                screen.md || <Header style={{ height: "100px", backgroundColor:"#f0f2f5" }}>
                    <Row justify="center">
                    <Button onClick={() => setDrawerVisible(true)} icon={<FontAwesomeIcon icon={faBars} />} style={{ position: "relative", left: "-25%", top: "34px", zIndex: 9999, color: "black", backgroundColor: "#f0f2f5" }} ></Button>
                        <NavLink to="/">
                            {

                                <img alt="logo_full" height={"80px"} style={{ objectFit: "cover", marginTop: "10px", marginBottom: "2px" }} src={process.env.PUBLIC_URL + '/assets/b2.png'} />
                            }
                        </NavLink>
                    </Row>
                </Header>
            }
            <Layout style={{ minHeight: "100vh" }}>
                <Content>
                    {props.children}        
                </Content>
                <Footer style={{ textAlign: 'center' }}>
                    Copyright © 2024 - 2026{/*  {<CodeIcon size={18} />} */} {/* with {<HeartFillIcon size={18} />}  */}{/* by XAVIER Project */} {/* <a href="http://www.qut.edu.au" target="_blank" rel="noreferrer"></a> */}
                </Footer>
            </Layout>
        </Layout>
    )
}
